import script from "./PasswordCriteria.vue?vue&type=script&lang=js"
export * from "./PasswordCriteria.vue?vue&type=script&lang=js"

import "./PasswordCriteria.vue?vue&type=style&index=0&id=5a4a6a3d&lang=scss"

const __exports__ = script;

export default __exports__